import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import store from "./store";
import router from "./router.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
